import { deleteRequest, get, post, put} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";


export const getNewsListFitler = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getNewsListFilter}${query?`?${query}`:""}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const addNews = async (data:any): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.addNews}`;
      const config = headers.content_type.application_json;
      return post<DataResponse<any>>(url, config);
    };
    export const updateNews = async (data:any): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.updatNewsWithPut}`;
      const config = headers.content_type.application_json;
      return put<DataResponse<any>>(url, data,config);
    };

    export const deleteNews = async (data:any): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.updatNewsWithPut}`;
      const config = headers.content_type.application_json;
      return deleteRequest<DataResponse<any>>(url, data,config);
    };
  